import type {
  DomainFieldsFragment,
  SubdomainFieldsFragment,
} from 'bundles/program-home/queries/__generated__/EnterpriseHomePageQuery';

// Transform fragment types to legacy types
export const transformDomainToLegacy = (domain: DomainFieldsFragment) => ({
  ...domain,
  slug: domain.slug ?? null,
  subdomainIds: domain.subdomainIds.filter((id) => id !== null) as string[],
});

export const transformSubdomainToLegacy = (subdomain: SubdomainFieldsFragment) => ({
  ...subdomain,
  domainId: subdomain.domain.id,
});

// Type definitions for the legacy structure
export type LegacyDomain = ReturnType<typeof transformDomainToLegacy>;
export type LegacySubdomain = ReturnType<typeof transformSubdomainToLegacy>;

// Helper functions for arrays with null filtering
export const transformDomainsToLegacy = (domains: DomainFieldsFragment[]) =>
  domains.filter((domain) => domain !== null).map(transformDomainToLegacy);

export const transformSubdomainsToLegacy = (subdomains: SubdomainFieldsFragment[]) =>
  subdomains.map(transformSubdomainToLegacy);
